import * as SX from '@aibees/elephant/components/list-type-select/sx';
import { TableFilterSelectOption } from '@aibees/elephant/components/table-filter-select';
import { ExportSearchGrouping } from '@aibees/elephant/hooks';

export const LIST_TYPE_OPTION: TableFilterSelectOption[] = [
  {
    key: `${ExportSearchGrouping.COMPANY},${ExportSearchGrouping.PERSON}`,
    value: 'All Types',
  },
  {
    key: ExportSearchGrouping.COMPANY,
    value: 'Company',
    icon: 'business',
    iconSx: SX.companyIcon,
  },
  {
    key: ExportSearchGrouping.PERSON,
    value: 'People',
    icon: 'people-outline',
    iconSx: SX.contactIcon,
  },
];
